import { DoctorFullResponse } from '@/api/doctors/doctors.types';

export interface ITestimonialItem {
  author_name: string;
  phone?: string | null;
  email?: string | null;
  medical_unit_id?: number | null;
  doctor_id?: number | null;
  service_id?: number | null;
  text: string;
  score?: number;
  publication_consent: boolean;
  testimonial_type?: string | null;
  status?: string | null;
  publication_date?: string | null;
  admin_response?: string | null;
  response_date?: string | null;
  id: number;
  created_at: string;
  updated_at?: string;
  medical_unit?: object | null;
  doctor?: DoctorFullResponse | null;
  service?: object | null;
}

export enum TestimonialType {
  'Отзыв о враче' = 'Отзыв о враче',
  'Отзыв о клинике' = 'Отзыв о клинике',
}

export type TestimonialsListOptions = {
  page?: number;
  per_page?: number;
  search?: string;
  order_by?: string;
  testimonial_type?: TestimonialType | null;
}

export type TestimonialCreateBody = {
  author_name: string;
  phone?: string | null;
  email?: string | null;
  doctor_id: number | null;
  text: string;
  score?: number;
  publication_consent: boolean;
}